<template>
  <section id="ValueYourCar">
    <div id="main">
      <div class="main-box">
        <div class="container">
          <h2 v-html="$t('ValueYourCar.h2')"></h2>
          <span class="notes">*{{$t('form_c.mandatory')}}</span>
          <p class="mp-4 bor-b"></p>
          <div class="form-container">
            <p class="mp-6"></p>
            <form id="form"
                  ref="forms"
                  :model="valuationForm">
              <div class="form-section">
                <div class="form-column">

                  <div class="form-field">
                    <div class="form-field-label">
                      <label for="First"
                             class="wdform-label">*{{$t('ValueYourCar.from.name')}}</label>
                    </div>
                    <div class="form-field-row">
                      <div class="form-field-column">
                        <input type="text"
                               name="userFirstname"
                               v-validate="'required'"
                               :placeholder="$t('ValueYourCar.from.first')"
                               v-model="valuationForm.firstName">
                        <span class="textfield__counter ts"
                              v-show="errors.has('userFirstname')">{{ errors.first('userFirstname') }}</span>
                      </div>
                      <div style="padding: 0 8px"></div>
                      <div class="form-field-column">
                        <input type="text"
                               name="userLastname"
                               v-validate="'required'"
                               :placeholder="$t('ValueYourCar.from.last')"
                               v-model="valuationForm.lastName">
                        <span class="textfield__counter ts"
                              v-show="errors.has('userLastname')">{{ errors.first('userLastname') }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="form-field">
                    <div class="form-field-label">
                      <label for="first1"
                             class="wdform-label">*{{$t('ValueYourCar.from.email')}}</label>
                    </div>
                    <div class="form-field-row">
                      <div class="form-field-column">
                        <input type="text"
                               name="emailAdd"
                               v-validate="'required|email'"
                               :placeholder="$t('ValueYourCar.from.email')"
                               v-model="valuationForm.email">
                        <span class="textfield__counter ts"
                              v-show="errors.has('emailAdd')">{{ errors.first('emailAdd') }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="form-field">
                    <div class="form-field-label">
                      <label for="first1"
                             class="wdform-label">*{{$t('ValueYourCar.from.phone')}}</label>
                    </div>
                    <div class="form-field-row">
                      <div class="form-field-column">
                        <input type="text"
                               name="mobile"
                               v-validate="'required|numeric'"
                               :placeholder="$t('ValueYourCar.from.phone')"
                               v-model="valuationForm.phone">
                        <span class="textfield__counter ts"
                              v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-column">
                  <div class="form-field">
                    <div class="form-field-label">
                      <label for="first1"
                             class="wdform-label">*{{$t('ValueYourCar.from.carModel')}}</label>
                    </div>
                    <div class="form-field-row">
                      <div class="form-field-column">
                        <input type="text"
                               name="userCarModel"
                               v-validate="'required'"
                               :placeholder="$t('ValueYourCar.from.carModel')"
                               v-model="valuationForm.carModel">
                        <span class="textfield__counter ts"
                              v-show="errors.has('userCarModel')">{{ errors.first('userCarModel') }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="form-field">
                    <div class="form-field-label">
                      <label for="first1"
                             class="wdform-label">*{{$t('ValueYourCar.from.yearofthecar')}}</label>
                    </div>
                    <div class="form-field-row">
                      <div class="form-field-column">
                        <input type="text"
                               name="userCarYear"
                               v-validate="'required'"
                               :placeholder="$t('ValueYourCar.from.yearofthecar')"
                               v-model="valuationForm.carYear">
                        <span class="textfield__counter ts"
                              v-show="errors.has('userCarYear')">{{ errors.first('userCarYear') }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="form-field">
                    <div class="form-field-label">
                      <label for="first1"
                             class="wdform-label">{{$t('ValueYourCar.from.message')}}</label>
                    </div>
                    <div class="form-field-row">
                      <div class="form-field-column">
                        <textarea class="message"
                                  name="userMessage"
                                  rows="3"
                                  maxlength="200"
                                  :placeholder="$t('ValueYourCar.from.messageP')"
                                  v-model="valuationForm.message">
                        </textarea>
                        <!-- <span class="textfield__counter ts"  v-show="errors.has('userMessage')">{{ errors.first('userMessage') }}</span> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="w-100 mb-10"></div>
              <!-- <div id="privacy-fields">
                <div class="row">
                  <div class="col-sm-12 col-xs-12 col-md-10">
                    <p class="aui-small"
                       v-html="$t('kamlungmotorslimited')"></p>
                  </div>
                </div>
              </div> -->
              <div class="check-text">
                <div class="col-sm-12 col-xs-12 check-p">
                  <label class="aui-checkbox aui-js-checkbox"
                         @change="checkboxCl($event)">
                    <input class="aui-checkbox__input"
                           type="checkbox"
                           name="privacy"
                           v-validate="'seeyn'"
                           :value="valueyourcarForm.privacy ? true : false"
                           checked
                           v-model="valueyourcarForm.privacy">
                    <span class="aui-checkbox__label">
                      <strong>{{$t('Privacy_yn_1')}} <a href="javascript:;"
                           @click="showPopup()"
                           style="color: #000; font-weight: 600; text-decoration: underline;">{{locale == 'en' ? 'Privacy Policy' : '私隱政策'}}</a> {{$t('Privacy_yn_2')}}</strong>
                    </span>
                    <span :class="['aui-checkbox__box', valueyourcarForm.privacy == true ? 'is-checked' : '']"><span class="aui-checkbox__tick iconfont">&#xe60e;</span></span>
                    <span class="textfield__counter ys"
                          v-show="errors.has('privacy')">{{ errors.first('privacy') }}</span>
                  </label>
                </div>
                <div class="col-sm-12 col-xs-12 check-p">
                  <label class="aui-checkbox aui-js-checkbox ml-4"
                         @click="checkboxCl($event)">
                    <input class="aui-checkbox__input"
                           type="checkbox"
                           name="receiveMessage"
                           :value="valuationForm.receiveMessage ? true : false"
                           checked
                           v-model="valuationForm.receiveMessage">
                    <span class="aui-checkbox__label"><strong v-html="$t('warranty')"></strong></span>
                    <span :class="['aui-checkbox__box', valuationForm.receiveMessage == true ? 'is-checked' : '']"><span class="aui-checkbox__tick iconfont">&#xe60e;</span></span>
                   
                    <span class="textfield__counter ys grey" >{{ $t('PINNED') }}</span>
                  </label>
                </div>
              </div>
              <div class="form-btn">
                <button type="button"
                        class="button-submit"
                        @click="onSubmit()"
                        data-ajax="0">
                  <span class="fm-submit-loading spinner fm-ico-spinner"></span>{{$t('submit')}}
                </button>
              </div>
            </form>
          </div>
          <p class="mp-6 bor-b"></p>
        </div>
      </div>
    </div>
    <van-popup class="van-popup1"
               closeable
               close-icon="close"
               v-model="showPrivacyPolicy">
      <PrivacyPolicy v-if="locale == 'zh' ? true : false" />
      <PrivacyPolicyEn v-if="locale == 'en' ? true : false" />
    </van-popup>
    <div hidden>易手車</div>
  </section>
</template>

<script>
import { reqAddValuationCar } from '../untils/api.js';
import { Toast, Button, Popup } from 'vant'
import PrivacyPolicy from '../components/PrivacyPolicy/PrivacyPolicyCn'
import PrivacyPolicyEn from '../components/PrivacyPolicy/PrivacyPolicyEn'

export default {
  metaInfo: {
    title: 'Valuation of your car', // set a title
    meta: [{             // set meta
      name: 'keywords',
      content: 'Valuation of your car'
    },
    {
      name: 'description',
      content: 'Valuation of your car'
    }]
  },
  name: "ValueYourCar",
  inject: ['reload'],
  data () {
    return {
      locale: this.$store.state.locale,
      showPrivacyPolicy: false,

      valueyourcarForm: {
        privacy: false
      },

      valuationForm: {
        lastName: '', //姓名-姓
        firstName: '', //姓名-名
        carModel: '',  //车型
        carYear: '', //汽车日期
        phone: '', //电话
        email: '', //Email
        message: '', //内容框
        receiveMessage: false,   //是否同意锦龙获取隐私

        privacy: false,
      }
    };
  },
  components: {
    PrivacyPolicy,
    PrivacyPolicyEn
  },
  mounted () {
    PubSub.subscribe('locale', (msg, data) => {
      if (data.locale != '') {
        this.reload()
        this.$validator.locale = this.$store.state.locale
      }
    })
  },
  methods: {
    showPopup () {
      this.showPrivacyPolicy = true
    },

    onSubmit () {
      this.$validator.validate().then(result => {
        if (!result) {
          Toast({ message: this.errors.all()[0], duration: 1500 });  // ui框架的提示弹窗
          return
        } else {
          if (this.valueyourcarForm.privacy == true) {
            let _ = this.valuationForm
            let data = {
              lastName: _.lastName,
              firstName: _.firstName,
              carModel: _.carModel,
              carYear: _.carYear,
              phone: _.phone,
              email: _.email,
              message: _.message, //内容框
              receiveMessage: _.receiveMessage, //是否同意隐私
            }
            setTimeout(async () => {
              let res = await reqAddValuationCar(data)
              if (res.code == 200) {
                this.load = false
                Toast({ type: 'success', duration: 2000 })
                this.reload()
              }
            }, 700)
          } else {
            Toast({ message: '*This is required.', duration: 2000 });  // ui框架的提示弹窗
          }
          //  this.handleSaveParam();   // 验证通过后请求接口的方法
        }
      })
    },

    checkboxCl (e) {
      // console.log('e', e)
      if (e.type == 'change') {
        if (e.target.checked == true) {
          console.log('this.valueyourcarForm.privacy1', this.valueyourcarForm.privacy)
          console.log('this.valuationForm.receiveMessage', this.valuationForm.receiveMessage)
          e.currentTarget.firstElementChild.nextElementSibling.nextElementSibling.classList.add('is-checked')
        } else if (e.target.checked == false) {
          console.log('this.valueyourcarForm.privacy2', this.valueyourcarForm.privacy)
          console.log('this.valuationForm.receiveMessage', this.valuationForm.receiveMessage)
          e.currentTarget.firstElementChild.nextElementSibling.nextElementSibling.classList.remove('is-checked')
        }
      }
    },

  }
};
</script>

<style scoped lang="scss">
[type=reset], [type=submit], button, html [type=button] {
  -webkit-appearance: button;
}

.em {
  font-size: 14px;
  font-style: italic;
  color: #8d8d8d;
}

#ValueYourCar {
  #main {
    font-size: 16px;

    // background: url('../picture/bg.jpg') repeat center top fixed;
    .main-box {
      .notes {
        color: #8d8d8d;
        font-style: italic;
      }

      .form-container {
        margin: 0 auto;
        width: 80%;

        form {
          margin: 10px auto;
          border-radius: 0px;
          background: rgba(237, 237, 237, 0.36);

          .form-section {
            padding: 10px 15px;
            display: flex;
            display: -webkit-flex;
            width: 100%;
            -webkit-flex-direction: row;
            flex-direction: row;
            background: rgba(243, 243, 243, 0.36);

            .form-column {
              display: flex;
              flex-direction: column;
              width: 50%;

              .form-field {
                padding: 8px 10px 14px;
                position: relative;
                display: flex;
                flex-direction: column;

                .form-field-label {
                  margin-bottom: 5px;
                  text-align: left;
                  -webkit-flex-direction: row;
                  flex-direction: row;
                }

                .form-field-row {
                  display: flex;
                  display: -webkit-flex;
                  width: 100%;
                  -webkit-flex-direction: row;
                  flex-direction: row;

                  .form-field-column {
                    position: relative;
                    display: flex;
                    display: -webkit-flex;
                    width: 100%;
                    height: 100%;
                    align-items: baseline;
                    justify-content: flex-end;

                    input {
                      height: 40px;
                    }

                    input, textarea {
                      padding: 0px 5px;
                      margin: 0px;
                      width: 100%;
                      border-bottom: 1px !important;
                      border-bottom-style: solid !important;
                      border-bottom-color: #dfdfdf !important;
                      border-right: 1px !important;
                      border-right-style: solid !important;
                      border-right-color: #dfdfdf !important;
                      border-left: 1px !important;
                      border-left-style: solid !important;
                      border-left-color: #dfdfdf !important;
                      border-top: 1px !important;
                      border-top-style: solid !important;
                      border-top-color: #dfdfdf !important;
                    }
                  }
                }
              }
            }
          }

          .form-btn {
            background: rgba(237, 237, 237, 0.36);

            button {
              font-size: 16px;
              color: #ffffff;
              width: 100%;
              height: 44px;
              border: none;
              background-color: #ae0526;
              box-shadow: 1px 1px 2px #ccc;
            }
          }
        }
      }
    }
  }

  // 第五横，多选按钮
  .aui-checkbox {
    float: left;
    // display: inline-block;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    font-weight: 400;
    height: 44px;
    // line-height: 30px;
    // margin-top: 10px;
    margin-top: 0;
    padding-left: 50px;
    padding-right: 20px;
    margin-right: 16px;
    color: #000;
    box-shadow: 0 0 3px 3px rgba(255, 255, 255, 0.2);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    transition: color, border;
    transition-duration: 0.25s;
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
    cursor: pointer;

    &:hover {
      .aui-checkbox__label {
        color: rgba(0, 0, 0, 1);
      }

      .aui-checkbox__box {
        border-color: rgba(0, 0, 0, 0.8);
      }
    }

    .aui-checkbox__label {
      font-size: 16px;
    }

    .aui-checkbox__input {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      position: absolute;
      width: 0;
      height: 0;
      overflow: hidden;
      margin: 0;
      padding: 0;
      border: 0;
      outline: 0;
      opacity: 0;
      z-index: -1;

      &:focus~.aui-checkbox__box {
        box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.1);
      }
    }

    .aui-checkbox__box {
      display: inline-block;
      overflow: hidden;
      position: absolute;
      top: 7px;
      left: 0;
      width: 30px;
      height: 30px;
      border: 1px solid rgba(0, 0, 0, 0.5);
      transition: box-shadow 0.15s linear, border 0.15s linear;
      cursor: pointer;
      pointer-events: none;
      z-index: 1;

      .aui-checkbox__tick {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: rgba(0, 0, 0, 0.5);
        transform: translate(-50%, -50%);
        opacity: 0;
        transition: opacity 0.15s cubic-bezier(0.75, 0.02, 0.5, 1);
        pointer-events: none;
      }

      &.is-checked .aui-checkbox__tick {
        opacity: 1;
      }
    }
  }

  // 隐私
  #privacy-fields {
    padding: 10px 15px;
    background: rgba(243, 243, 243, 0.36);

    .aui-small {
      margin: 0 10px;
      font-size: 15px;
      line-height: 1.5;
    }
  }

  // 隐私
  .check-text {
    padding: 10px 15px;
    overflow: hidden;
    background: rgba(243, 243, 243, 0.36);

    .check-p {
      padding-top: 5px;
      padding-bottom: 10px;
      overflow: hidden;

      .aui-checkbox {
        margin: 0;
        // height: auto;
        box-shadow: none;
        -webkit-box-shadow: none;

        .aui-checkbox__box {
          .aui-checkbox__tick {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;
            height: 100%;
            line-height: normal;
            color: #fff;
            background: #000;
          }
        }

        .aui-checkbox__label {
          font-size: 14px;
        }
      }
    }
  }

  // 验证提示
  .textfield__counter {
    position: absolute;
    margin-top: 0;
    font-size: 12px;
    color: red;

    &.ys {
      bottom: -11px;
      margin-top: 0;
    }

    &.ts {
      left: 1px;
      bottom: -17px;
    }
    
		&.grey {
			color: #666;
		}
  }

  @media (max-width: 996px) {
    #main {
      .main-box {
        .form-container {
          form {
            .form-section {
              display: block;

              .form-column {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    #main {
      font-size: 15px;

      .main-box {
        .form-container {
          width: 100%;

          form {
            .form-section {
              .form-column {
                .form-field {
                  padding: 8px 2px 14px;
                }
              }
            }
          }
        }
      }
    }

    .aui-checkbox {
      padding-right: 0;
    }

    #privacy-fields .aui-small {
      font-size: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ValueYourCar.vue